import { useDatabaseStore } from "@/stores/database";
import { useDataflowStore } from "@/stores/dataflow";
import { useEffect } from "react";
import { useParams } from "react-router";

export function DataflowPage() {
  const { dataflowId, projectId } = useParams();
  const setActiveDataflow = useDataflowStore(
    (state) => state.setActiveDataflow
  );
  const getDataflowById = useDatabaseStore((state) => state.getDataflowById);
  const addDataflow = useDataflowStore((state) => state.addDataflow);

  useEffect(() => {
    if (dataflowId) {
      const dataflowStore = useDataflowStore.getState();
      if (!dataflowStore.dataflows[dataflowId]) {
        const dbDataflow = getDataflowById(dataflowId);
        if (dbDataflow) {
          addDataflow(dataflowId, {
            ...dbDataflow,
            dataflow_name: dbDataflow.dataflow_name || undefined,
            dataflow_description: dbDataflow.dataflow_description || undefined,
            flow_definition_json:
              (dbDataflow.flow_definition_json as any) || [],
          });
        }
      }
      setActiveDataflow(dataflowId);
    }
  }, [dataflowId, projectId, setActiveDataflow, getDataflowById, addDataflow]);

  return null;
}
